import type { Schema, ValidationError } from 'yup'

export const getInputElementFromForm = (fieldName: string, form: HTMLFormElement) => {
    return Array.from(form.elements).filter(
        (element: Element) => (element as HTMLInputElement).name === fieldName,
    )?.[0] as HTMLInputElement | undefined
}

/**
 * @memberof useValidateSchema
 * @description
 * validates provided field names and sets custom validity on their corresponding elements
 * */
export const validateFieldsAndSetValidity = (fieldNames: string[], schema: Schema, form: HTMLFormElement) => {
    const errors: ValidationError[] = []
    const formObject: Record<string, FormDataEntryValue> = {}
    new FormData(form).forEach((value, key) => {
        formObject[key] = value
    })
    fieldNames.forEach((field) => {
        const input = getInputElementFromForm(field, form)
        if (!input) {
            return
        }
        try {
            schema.validateSyncAt(field, formObject, { abortEarly: false })
            // message must be an empty string
            input.setCustomValidity('')
        } catch (error) {
            // message will not be visible to the user. It only matters that the string is not empty
            input.setCustomValidity('not valid')

            errors.push(...(error as ValidationError).inner)
        }
    })
    return errors
}
